import { Component, OnInit } from "@angular/core";
import { DownloadAllConfig } from "../download-all/models/download-all-config";
import { SkuManagementService } from "./sku-management.service";

@Component({
    selector: "app-sku-management",
    templateUrl: "./sku-management.component.html",
    styleUrls: ["./sku-management.component.scss"],
    standalone: false
})
export class SkuManagementComponent implements OnInit {
  title: string;
  guidButtonLabel: string;
  showGuidButton: boolean;
  downloadAllConfig: DownloadAllConfig;

  constructor(private skuManagementService: SkuManagementService) {}

  ngOnInit() {
    this.title = this.skuManagementService.getTitle();
    this.guidButtonLabel = this.skuManagementService.getGuidButtonLabel();
    this.showGuidButton = this.skuManagementService.showGuidButton();
    this.downloadAllConfig = this.skuManagementService.getDownloadAllConfig();
  }
}
